module.exports = __webpack_public_path__ + "static/media/down.cefc206c.svg";